import { UnlinkedInputOverviewTable } from '@/components';

export default {
  name: 'UnlinkedInputOverview',
  components: {
    UnlinkedInputOverviewTable,
  },
  props: {},
  data: () => ({

  }),
  computed: {},
  methods: {},
};
